export const roles = {
  Platform: [
    'dashboard',
    'accounts',
    'adverts',
    'customers',
    'funders',
    'partners',
    'banks',
    'referrals',
    'dialler',
    'billing',
    'questions',
    'platforms',
    'brokers',
    'maintenance',
    'imports'
  ],

  'Super Admin': [
    'dashboard',
    'accounts',
    'customers',
    'funders',
    'partners',
    'banks',
    'referrals',
    'billing',
    'questions',
    'platforms',
    'brokers'
  ],

  Provider: ['dashboard', 'funders', 'referrals'],

  Partner: ['dashboard', 'partners', 'referrals'],

  Referrer: ['referrals'],

  Bank: ['banks', 'referrals'],

  'Call Centre': ['customers', 'referrals'],

  Broker: ['referrals', 'brokers'],

  'Property Broker': ['customers', 'maintenance', 'user'],

  Accounts: ['billing']
};
